import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { reviews } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-cream py-16 sm:py-20" aria-labelledby="reviews-title" data-id="element-257" data-mp="3ksqhhcu0zq9n">
      <div className="mx-auto max-w-6xl px-4" data-id="element-258" data-mp="3fxkv6cwpo9l1">
        <p className="text-center text-xs font-extrabold uppercase tracking-[.18em] text-earth" data-id="element-259" data-mp="3b1ckbbpjr2jo">Lo que dicen los que ya lo tienen</p>
        <h2 id="reviews-title" className="mt-3 text-center text-3xl font-extrabold text-field sm:text-4xl" data-id="element-260" data-mp="370k8qbt7clk8">
          Yacimientos de Hidrocarburos con contexto argentino
        </h2>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-261" data-mp="2x1utkqsoxf7o">
          {reviews.map(([initials, name, role, quote, color], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex min-h-[280px] flex-col rounded-xl border border-line bg-white p-6 text-ink shadow-card" data-id="element-262" data-mp="2s3jgm773mol8" data-mpi={index}>
              <div className="flex text-gold" aria-label="5 de 5 estrellas" data-id="element-263" data-mp="78aa1dnz7lg6">
                {Array.from({
              length: 5
            }, (_, star) => <StarIcon key={star} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-264" data-mp="c7deox01npnm" />)}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-muted" data-id="element-265" data-mp="zyiwhhpjos0k">“{quote}”</blockquote>
              <div className="mt-auto flex items-center gap-3 border-t border-line pt-4" data-id="element-266" data-mp="14xddqf7v68ik">
                <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-md text-sm font-extrabold text-cream ${color}`} data-id="element-267" data-mp="q4jz0w0f1wey">
                  {initials}
                </span>
                <span data-id="element-268" data-mp="1itz65aoyn55l">
                  <b className="block text-sm text-ink" data-id="element-269" data-mp="1nm0g2pynojsg">{name}</b>
                  <small className="text-xs text-muted" data-id="element-270" data-mp="1nnbkmrzxdvkm">{role}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}